import { ResolveFn } from '@angular/router';
import { SystemImageResponse } from '../models/system-image.model';
import { inject } from '@angular/core';
import { SystemImageQueryService } from '../services/system-image-query.service';
import { injectQuery } from '@tanstack/angular-query-experimental';

export const systemImageResolver: ResolveFn<SystemImageResponse[]> = async (_route, _state) => {
  const query = injectQuery(() => inject(SystemImageQueryService).getSystemImageOptions());

  return await query.promise();
};
